
<template>
  <!--新增栏目-->
  <x-addEdit
    apiOrigin="PHP"
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
export default {
  name: 'addColumn',
  data () {
    return {
      formList: [
        {
          label: '栏目名',
          inputType: 'input',
          options: [],
          placeholder: '请输入栏目名',
          props: ['title', {
            rules: [
              { pattern: /^[\u4e00-\u9fa5\w-]{0,4}$/, message: '汉字、字母、数字，不超过4个字' },
              { required: true, message: '请输入栏目名' }
            ]
          }]
        },
        {
          label: '类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择类型',
          // disabled: true,
          props: ['type', { // 参数1 传该值给后台时后台定义的字段名
            rules: [{ required: true, message: '请选择所属类型' }]
          }]
        }
      ],
      formKey: {
        title: undefined,
        type: undefined
      },
      addParam: {
        url: '/circle/columns',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/circle/columns/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/circle/columns/',
        resHandle: '' // this.resHandle
      }
    };
  },
  created () {
    if (this.$route.query.id) {
      this.formList[1].disabled = true;
    }
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      let type;
      this.$route.query.id ? type = 'mod' : type = 'add';

      this._get({
        url: '/circle/columns/selectlist',
        params: { from: type }
      }).then(({data}) => {
        if (type === 'add' && data.type.length === 1 && data.type[0].value === 0) {
          this.formList[1].disabled = true;
          this.$refs.addEdit.form.setFieldsValue({type: 0});
        }

        this.formList[1].options = data.type;
      });
    },
    resHandle (res) {
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
